module.exports = __webpack_public_path__ + "system/img/abbreviationSmall.b17dca11.png";